import { Link } from 'react-router-dom';
import styled from 'styled-components';

import PageHeader from 'components/pageHeader/PageHeader';
import CommonTable from 'components/table/CommonTable';
import mediaQuery from 'styles/mediaQuery';
import { SystemTemplateRow } from './SystemTemplatesTab.types';

export const SystemTemplatesHeaderStyled = styled(PageHeader)`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
`;

export const SystemTemplatesTableStyled = styled(
  CommonTable<SystemTemplateRow>,
)`
  tbody tr {
    max-height: 37px;
  }

  .body-cell-status > div {
    margin-bottom: -8px;
    margin-top: -11px;
  }

  .column-actions {
    width: 70px;
  }

  .column-name {
    width: 210px;
  }

  .column-status {
    width: 61px;
  }

  ${mediaQuery.xs} {
    .column-header-status,
    .body-cell-status {
      background-color: white;
      position: sticky;
      right: 0;
    }

    .column-header.column-header-actions,
    .body-cell.body-cell-actions {
      right: 60px;
    }
  }
`;

export const SystemTemplatesSectionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

export const EditLinkStyled = styled(Link)`
  display: inline-block;
  padding: 6px 12px;
`;

export const SystemTemplatesTabGlobalToggleStyled = styled.label`
  align-items: center;
  align-self: end;
  display: flex;
  font-weight: normal;
  margin-top: 10px;

  .toggle-switch {
    scale: 0.7;
  }
`;

export const SystemTemplatesModalFooter = styled.div`
  display: flex;
  justify-content: end;

  button:first-child {
    margin-right: auto;
  }
`;
